import ApiService from "./api.service";

class AdBannerService extends ApiService {
    async getBanner(zone){
        try {
            const result = await this.get(`api/meeting/ads/${zone}`);
            return result;
        }
        catch{
            return null;
        }
    }
}
export default new AdBannerService();